import { CssBaseline, IconButton } from "@mui/material";
import React from "react";
import { AppbarContainer, AppbarHeader, LogoImage } from "../../styles/appbar";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import Actions from "./actions";
import { useUIContext } from "../../context/ui";
import logo from "../../assets/logo.png";

export default function AppbarMobile({ matches, onLoginClick, onLogoutClick }) {
  const { setDrawerOpen, setShowSearchBox } = useUIContext();
  return (
    <AppbarContainer>
      <CssBaseline />
      <IconButton onClick={() => setDrawerOpen(true)}>
        <MenuIcon />
      </IconButton>
      <LogoImage src={logo}></LogoImage>
      <IconButton onClick={() => setShowSearchBox(true)}>
        <SearchIcon />
      </IconButton>
      <Actions
        onLogin={onLoginClick}
        onLogout={onLogoutClick}
        matches={matches}
      />
    </AppbarContainer>
  );
}
